import classnames from 'classnames';
import styles from 'components/common/NumberLabel/index.less';
import React from 'react';

interface INumberLabel {
  value?: string | number;
  active?: boolean;
  square?: boolean;
}

/**
 * A React function component that displays a label.
 *
 * @param {INumberLabel} props - The component props.
 * @param {string | number | undefined} props.value - The value to be displayed in the label. This can be a string or number.
 * @param {boolean | undefined} props.active - A boolean indicating whether the label is active or not.
 * @param {boolean | undefined} props.square - A boolean indicating whether the label is square or not.
 *
 * @returns {JSX.Element} The rendered number label.
 */
const NumberLabel: React.FC<INumberLabel> = ({ value = '', active = false, square = false }) => {
  return (
    <div
      className={classnames(
        styles.numberLabel,
        { [styles.active]: active },
        { [styles.square]: square },
      )}
    >
      {value}
    </div>
  );
};

export default NumberLabel;
